import { h, render } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import 'preact/debug';
import 'src/app/i18n';

import 'src/common/assets/fonticons/font/iconFont.css';
import 'src/common/templates/styling/default.layout/header/index.scss';
import 'src/common/templates/styling/default.theme/header/index.scss';
import 'src/common/templates/styling/default.layout/modals/ResultModal.scss';
import 'src/common/templates/styling/default.layout/modals/MyBetsModal.scss';
import 'src/common/templates/styling/default.theme/modals/MyBetsModal.scss';
import 'src/app/assets/scss/main.scss';

const Main = lazy(() => import('src/app/components/Pages/Main'));
import Render from 'src/app/components/Pages/Render';

import setHtmlMeta from 'src/common/helpers/setHtmlMeta';
setHtmlMeta('Turbo Plinko', 'turboplinko', 'turboplinko');

const app = document.getElementById('app');
const { pathname } = window.location;

if (app) {
    render(
        <Suspense fallback={<div />}>
            {pathname === '/render' ? <Render /> : <Main />}
        </Suspense>,
        app,
    );
}
